import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import history from 'lib/history';

import CourseItem from './CourseItem';

const CourseItemContainer = ({ course, day, ...props }) => {
  const { t } = useTranslation();
  const handleCourseStudy = useCallback(() => {
    if (day.isToday && course.nQuestionsToStudy > 0 && !course.isPast) {
      history.push(`/study/${course.id}?method=wooflash`);
    }
  }, [course, day]);
  return (
    <CourseItem
      course={course}
      day={day}
      handleCourseStudy={handleCourseStudy}
      t={t}
      {...props}
    />
  );
};

CourseItemContainer.propTypes = {
  course: PropTypes.object.isRequired,
  day: PropTypes.object.isRequired,
};

export default CourseItemContainer;
